var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1779 11.905C13.1779 7.92628 15.5861 5.38642 17.2969 4.14393C17.8566 3.73745 18.4499 4.2501 18.3656 4.95565L18.1306 7.92628H20.0001C21.1047 7.92628 22.0001 8.82171 22.0001 9.92628V16C22.0001 17.1046 21.1047 18 20.0001 18H15.1779C14.0733 18 13.1779 17.1046 13.1779 16V11.905Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.905C2 7.92628 4.40821 5.38642 6.119 4.14393C6.67868 3.73745 7.27201 4.2501 7.18775 4.95565L6.95273 7.92628H8.82223C9.9268 7.92628 10.8222 8.82171 10.8222 9.92628V16C10.8222 17.1046 9.9268 18 8.82223 18H4C2.89543 18 2 17.1046 2 16V11.905Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt5);
export default __webpack_public_path__ + "static/media/quote-alt-5.bb622ea71f5c89a07ad0cb775b7a8169.svg";
export { ForwardRef as ReactComponent };